import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

export const api = {
  getAllDeals: () => axios.get(`${API_BASE_URL}/deals`),
  getPublicDeals: () => axios.get(`${API_BASE_URL}/public-deals`),
  verifyMOU: (dealId, password) => axios.post(`${API_BASE_URL}/verify-mou`, { dealId, password }),
  verifyPayment: (dealId, password) => axios.post(`${API_BASE_URL}/verify-payment`, { dealId, password }),
};
